<template lang="pug">
    app-modal(type="default" v-model="value.isOpen")
      template(slot="title") プロフィール
      profile-box(:userId="value.userId")
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import ProfileBox from '@/components/organisms/ProfileBox'

export default {
  name: 'ModalProfile',
  components: { AppModal, ProfileBox },
  props: {
    /*
     * isOpen: 開閉状態
     * userId: ユーザーID
     */
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          isOpen: false,
          userId: null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalProfile.vue